import React, { Component } from "react";
import { apiService } from "../../base/utils/service";
import Spinner from "../../base/features/micro/Spinner";
import DynamicCategory from "./blocks/DynamicCategory";
import DynamicProducts from "./blocks/DynamicProducts";
import DynamicSummary from "./blocks/DynamicSummary";
import DynamicNotice from "./blocks/DynamicNotice";
import DynamicCircle from "./blocks/DynamicCircle";
import DynamicBadge from "./blocks/DynamicBadge";
import DynamicAccessory from "./blocks/DynamicAccessory";
import DynamicBanner from "./blocks/DynamicBanner";
import DynamicMiniBanner from "./blocks/DynamicMiniBanner";
import DynamicGrid2 from "./blocks/DynamicGrid2";
import { dynamicVersion } from "../../settings/config";
import DynamicProducts2 from "./blocks/DynamicProducts2";
import DynamicVerticalProduct from "./blocks/DynamicVerticalProduct";
import DynamicGridProduct from "./blocks/DynamicGridProduct";
import DynamicCategoryScroll from "./blocks/DynamicCategoryScroll";
import DynamicSummary1 from "./blocks/DynamicSummary1";
import DynamicSummary2 from "./blocks/DynamicSummary2";
import DynamicSummary3 from "./blocks/DynamicSummary3";
import DynamicAds from "./blocks/DynamicAds";

class DynamicView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      views: null,
    };
  }

  componentDidMount() {
    if (this.props.viewPage === "home") {
      this.getHomeView();
    }
    if (this.props.viewPage === "dashboard") {
      this.getDashboardView();
    }
    if (this.props.viewPage === "shopHome") {
      this.getShopHomeView();
    }
    if (this.props.viewPage === "category") {
      this.getCategoryView();
    }
    if (this.props.viewPage === "page") {
      this.getPageView();
    }
  }
  getShopHomeView() {
    this.setState({ views: this.props.view || [] });
  }
  getHomeView() {
    apiService(`v1/pages/home/views?version=${dynamicVersion}`, "get").then(
      (data) => {
        data && this.setState({ views: data });
      }
    );
  }
  getPageView() {
    this.setState({ views: this.props.views || null });
  }
  getCategoryView() {
    apiService(
      `v1/pages/categories/views?version=${dynamicVersion}`,
      "get"
    ).then((data) => {
      data && this.setState({ views: data });
    });
  }
  getDashboardView() {
    apiService(
      `v1/pages/shop-dashboard/views?version=${dynamicVersion}&shop=${
        window.location.pathname.split("/")[2]
      }`,
      "get"
    ).then((data) => {
      data && this.setState({ views: data });
    });
  }
  renderSwitch(param, view) {
    switch (param) {
      case "category":
        return <DynamicCategory view={view} />;
      case "ads":
        return <DynamicAds view={view} />;
      case "category_scroll":
        return <DynamicCategoryScroll view={view} />;
      case "product":
        return <DynamicProducts view={view} />;
      case "shop_product_list":
        return <DynamicProducts view={view} />;
      case "product_2":
        return <DynamicProducts2 view={view} />;
      case "vertical_product":
        return <DynamicVerticalProduct view={view} />;
      case "shop_product_grid":
        return <DynamicGridProduct view={view} />;
      case "summary":
        return <DynamicSummary view={view} />;
      case "summary_1":
        return <DynamicSummary1 view={view} />;
      case "summary_2":
        return <DynamicSummary2 view={view} />;
      case "summary_3":
        return <DynamicSummary3 view={view} />;
      case "notice":
        return <DynamicNotice view={view} />;
      case "circle":
        return <DynamicCircle view={view} />;
      case "badge":
        return <DynamicBadge view={view} />;
      case "accessory":
        return <DynamicAccessory view={view} />;
      case "banner":
        return <DynamicBanner view={view} />;
      case "slider":
        return <DynamicBanner view={view} />;
      case "mini_banner":
        return <DynamicMiniBanner view={view} />;
      case "grid_2":
        return <DynamicGrid2 view={view} />;
      default:
        return "";
    }
  }
  render() {
    return (
      <div className="px-0">
        {this.state.views ? (
          this.state.views.map((view, v) => this.renderSwitch(view.type, view))
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    );
  }
}

export default DynamicView;
